// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import India from '../_raw/flag/icon_flag_india.png';

export default () => <img src={India} alt="India" />;
